import axios from "axios";
import config from "infra/config";

const api = axios.create({
  baseURL: config.urlApi,
});

export default api;
